import { AddCircleOutlineTwoTone, EditTwoTone } from "@mui/icons-material";
import { Button, Fab, Hidden, Icon, IconButton } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import MatIcon from "./matIcon";
const ButtonLinkIcon = ({ link, item, title, icon,type="normal",color="info", variant = "contained",size="small", onButtonClick,...rest }) => {
  const { t } = useTranslation(["common"]);



  function getIcon(name,color){

    switch (name) {
      case "add_circle":
        
        return <AddCircleOutlineTwoTone color={color}/>;
    case "edit":
      return <EditTwoTone color={color} />
      case "delete":
        return 
      default:
        break;
    }

  }


    return (
      <React.Fragment>
          {link ? (
            <Link to={link}>
              <IconButton title={title} color={color} aria-label={title} {...rest} size="large">
                {/* <Icon baseClassName="material-icons-two-tone">{icon}</Icon> */}
                <MatIcon name={icon} color={color} />
              </IconButton>
            </Link>
          ) : (
            // <Link to={link}>
              <IconButton
                title={title}
                color={color}
                aria-label={title}
                onClick={(event) => onButtonClick(item,event)}
                // style={{padding:"0px"}}
                {...rest}
                size="large">
                {/* <Icon baseClassName="material-icons-two-tone">{icon}</Icon> */}
                <MatIcon name={icon} color={color} />

              </IconButton>
            // </Link>
          )}
      </React.Fragment>
    );
};

export default ButtonLinkIcon;
